import {API_URL} from "../../dev";
import "isomorphic-fetch";

class BookingOfficeApi {
	async getBookingOffice(merchantId, themeName) {
		try {
			const bookingOfficeResponse = await fetch(
				`${API_URL}/v1/bookingOffices/${merchantId}_${themeName}`);
			const bookingOfficeObj = await bookingOfficeResponse.json();
			if (bookingOfficeResponse.ok) {
				return bookingOfficeObj;
			}
			throw bookingOfficeObj;
		} catch (e) {
			console.error(`Error occurred in getBookingOffices: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}
const bookingOfficeApi = new BookingOfficeApi();
export default bookingOfficeApi;
